import { request } from './index';
import {
  getExamReportsQueryKey,
  getExamReportsRankingQueryKey
} from '../hooks/react-query/use-exam-report';
import { ExamChartType } from './exam';
import { StudentOverviewType } from './student';

export type EduSubGroupType = {
  id: number;
  name: string;
  number: number;
} | null;

export type ExamReportType = {
  id: number;
  eduSubGroup: EduSubGroupType;
  correctQuestionCount: number;
  wrongQuestionCount: number;
  questionCount: number;
  score: number;
  rank: number | null;
  standardScore: number | null;
  scaledScore: number | null;
};

export type ExamReportRankingType = {
  id: number;
  exam: number;
  student: StudentOverviewType;
  rank: number;
  score: number;
  scaledScore?: number | null;
};

export type ExamReportChartType = {
  id: number;
  exam: ExamChartType;
  score?: number;
  scaledScore?: number | null;
};

export async function fetchExamReports({
  queryKey: [_, { examId }]
}: {
  queryKey: ReturnType<typeof getExamReportsQueryKey>;
}): Promise<ExamReportType[]> {
  return await request(true, { url: `/students/exam-reports/e-${examId}` });
}

export async function fetchExamReportsRanking({
  queryKey: [_, { examId }]
}: {
  queryKey: ReturnType<typeof getExamReportsRankingQueryKey>;
}): Promise<ExamReportRankingType[]> {
  return await request(true, { url: `/students/exam-reports/ranking/e-${examId}` });
}

export async function fetchExamReportsChartData(): Promise<ExamReportChartType[]> {
  return await request(true, { url: '/students/exam-reports/chart-data' });
}
